import React, { useEffect } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody
} from 'styled-modal-component';
import routeNames from "./../../utilities/server/routeNames";
import { StyledSearchModal } from "./styles";
import { SVGIcon } from "../Icons";
import logo from "../../../public/images/logo2x.avif";

const Search = ({
  context,
  clientContext,
  hidden,
  setHidden
}) => {
  const { isMobile, isTablet } = clientContext;
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (typeof _st === 'undefined') {
      (function(w,d,t,u,n,s,e){w['SwiftypeObject']=n;w[n]=w[n]||function(){
        (w[n].q=w[n].q||[]).push(arguments);};s=d.createElement(t);
        e=d.getElementsByTagName(t)[0];s.async=1;s.src=u;e.parentNode.insertBefore(s,e);
      })(window,document,'script','//s.swiftypecdn.com/install/v2/st.js','_st');

      _st('install','vkxR-Au7WC4iyZUzXr94','2.0.0');
    }
  }, []);

  useEffect(() => {
    document.addEventListener('click', (e) => {
      if (!e.target.matches('.st-ui-pagination-link')) {
        return;
      }

      document.querySelector('.search-modal-results').scrollIntoView();
    }, false);
  }, []);

  return (
    <StyledSearchModal isMobile={isMobile} isTablet={isTablet} isDesktop={!isMobile && !isTablet}>
        <Modal
          hidden={hidden}
          toggle={() => setHidden(!hidden)}
          wrapperProps={{
            className: 'search-modal-wrapper'
          }}
          dialogProps={{
            className: 'search-modal-dialog'
          }}
          contentProps={{
            className: 'search-modal-content'
          }}
          backdropProps={{
            className: 'search-modal-backdrop'
          }}
        >
          <ModalBody>
            <div className="search-modal-header">
              <div className="search-modal-container">
                <div className="search-modal-belt">
                  <div className="search-modal-logo">
                    <a href={routeNames.home} className="search-modal-logo-link">
                      <img src={logo} alt=""/>
                    </a>
                  </div>
                  <button onClick={() => setHidden(true)} className="search-modal-close">
                    <SVGIcon
                      iconName="closeIcon"
                    />
                  </button>
                </div>
                <form
                  className="search-modal-form"
                  onSubmit={(e) => handleSubmit(e)}
                >
                  <div className="search-modal-form-item">
                    <input
                      placeholder="What would you like to see?"
                      type="text"
                      className="st-default-search-input"
                    />
                    <SVGIcon iconName="search" />
                  </div>
                </form>
              </div>
            </div>
            <div className="search-modal-results">
              <div className="search-modal-container">
                <div className="st-search-container"></div>
              </div>
            </div>
          </ModalBody>
        </Modal>
    </StyledSearchModal>
  );
};

Search.propTypes = {
  context: PropTypes.object.isRequired,
  clientContext: PropTypes.object,
  hidden: PropTypes.bool,
  setHidden: PropTypes.func
};

export default Search;
